import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "checklist/regulation"

class service {

    selectList(params) {
        return http.list(path + "/selectList", params);
    }

    selectAll(params){
        return http.list(path + "/selectAll",params);
    }


}

export default new service();

